import { jobTypeList } from "constants/jobType";
import * as api from "../API/index";
import { authorizedUser } from "components/Common/commonFunctions";

// Get job type list
export const getJobTypeList = async (dispatch, { pageNum, filters } = {}) => {
  try {
    const res = await api.job_type_list(pageNum, filters);
    dispatch({ type: jobTypeList, payload: res.data });
  } catch (error) {
    dispatch({ type: jobTypeList, payload: error?.response?.data || error });
    authorizedUser(error.response?.data);
  }
};

// Add job type
export const addJobType = async (bodyData) => {
  try {
    const res = await api.add_job_type(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

// Edit job type
export const editJobType = async (id, bodyData) => {
  try {
    const res = await api.edit_job_type(id, bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};
